import { render, staticRenderFns } from "./VircosDocumentPrint.vue?vue&type=template&id=b9c520c0&scoped=true&"
import script from "./VircosDocumentPrint.vue?vue&type=script&lang=js&"
export * from "./VircosDocumentPrint.vue?vue&type=script&lang=js&"
import style0 from "./VircosDocumentPrint.vue?vue&type=style&index=0&id=b9c520c0&lang=scss&scoped=true&"
import style1 from "./VircosDocumentPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c520c0",
  null
  
)

export default component.exports